import { S25NotificationsComponent } from "../modules/s25-notifications/s25.notifications.component";
import { Timeout } from "../decorators/timeout.decorator";

export class NotificationService {
    public static notifications: any = [];

    public static barNotification: any = {};

    public static msgId: any = 0;

    public static PREPEND: any = "S25Notification-";

    public static getAll(): any {
        return NotificationService.notifications;
    }

    public static getBarNotification(): any {
        return NotificationService.barNotification;
    }

    public static removeById(id?: any): any {
        const n: any = NotificationService.notifications.filter(function (n: any) {
            return n.id === id;
        });
        n && n.length && NotificationService.remove(n[0]);
    }

    public static remove(notificationObj?: any): any {
        const idx: any = NotificationService.notifications.indexOf(notificationObj);
        if (idx > -1) {
            NotificationService.notifications.splice(idx, 1);
        }
        S25NotificationsComponent.refresh();
    }

    public static removeBarNotification(notificationObj?: any): any {
        notificationObj.barOpen = false;
        for (const prop in NotificationService.barNotification) delete NotificationService.barNotification[prop];
        const navbar: any = document.querySelector(".navbar");
        if (navbar) {
            navbar.style.marginBottom = "1.25rem";
        }
        S25NotificationsComponent.refresh();
    }

    @Timeout
    public static post(msg?: any, retention?: any, notificationClass?: any): any {
        if (msg) {
            NotificationService.msgId++;
            const newNotification: any = {
                id: NotificationService.PREPEND + NotificationService.msgId,
                msg: msg,
                notificationClass: notificationClass,
                remove: function () {
                    NotificationService.remove(newNotification);
                },
            };
            setTimeout(function () {
                //wrap in timeout to ensure s25-NotificationService.notifications knows about this new addition
                NotificationService.notifications.unshift(newNotification); //add to beginning of array
                S25NotificationsComponent.refresh();

                //dismiss promise can be passed in as retention
                let dismissPromise: any = retention && retention.then && retention;

                //dismissal can also be a number in ms
                if (!isNaN(parseInt(retention)) && parseInt(retention) > 0) {
                    //retention in ms
                    dismissPromise = new Promise((resolve, reject) => {
                        setTimeout(() => {
                            resolve(true);
                        }, parseInt(retention));
                    });
                }
                if (dismissPromise) {
                    dismissPromise.then(() => {
                        setTimeout(function () {
                            //wrap in timeout to ensure notification is added before we try to remove...
                            NotificationService.remove(newNotification);
                        });
                    });
                }
            });
            return newNotification;
        }
    }

    public static postBarNotification(
        message?: any,
        isSticky?: any,
        showClose?: any,
        showButton?: any,
        buttonFn?: any,
        buttonMsg?: any,
    ): any {
        if (message) {
            const newNotification: any = {
                message: message,
                showClose: showClose,
                barOpen: true,
                showButton: showButton,
                buttonMsg: buttonMsg || "Okay",
                buttonFn:
                    buttonFn ||
                    function () {
                        NotificationService.removeBarNotification(newNotification);
                    },
                remove: function () {
                    NotificationService.removeBarNotification(newNotification);
                },
            };
            setTimeout(function () {
                NotificationService.barNotification = Object.assign(
                    NotificationService.barNotification,
                    newNotification,
                );
                S25NotificationsComponent.refresh();
            });
            return newNotification;
        }
    }
}
export type PostBarNotification = {
    message: string;
    showClose: boolean;
    barOpen: boolean;
    showButton: boolean;
    buttonMsg: string;
    buttonFn: Function;
    remove: Function;
    isSticky?: boolean;
};
